import { Route, Routes } from 'react-router-dom';

import { NotFound } from '@/components/molecules/NotFound';
import { LICENSE_CODES, type LicenseCode } from '@/config/licenses';
import { useCage } from '@/contexts/cage';

import BehaviorDashboardContainer from './BehaviorDashboard/BehaviorDashboardContainer';
import BehaviorRespirationContainer from './BehaviorRespiration/BehaviorRespirationContainer';
import BehaviorSwimSpeedContainer from './BehaviorSwimSpeed/BehaviorSwimSpeedContainer';
import BehaviorTiltContainer from './BehaviorTilt/BehaviorTiltContainer';

/**
 * BehaviorLayout acts as a wrapper for all Behavior module pages
 * It handles internal routing for the behavior module
 * This allows the module to be self-contained while working with the existing sidebar system
 */
export default function BehaviorLayout() {
    const { hasLicenseByCode } = useCage();
    const hasBehaviorLicense = hasLicenseByCode(LICENSE_CODES.BEHAVIOR as LicenseCode);

    if (!hasBehaviorLicense) {
        return null;
    }

    return (
        <Routes>
            <Route index element={<BehaviorDashboardContainer />} />
            <Route path="swim-speed/*" element={<BehaviorSwimSpeedContainer />} />
            <Route path="respiration/*" element={<BehaviorRespirationContainer />} />
            <Route path="tilt/*" element={<BehaviorTiltContainer />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}
